export const parseCodeFromUrl = (): string | null => {
    if (typeof window === "undefined") return null;
    const m = window.location.pathname.match(/\/collection\/([^/?#]+)/i);
    return m?.[1] ? decodeURIComponent(m[1]) : null;
};

export const formatRub = (n?: number | null) =>
    typeof n === "number" ? n.toLocaleString("ru-RU") + " ₽" : "—";

export const installmentLabel = (
    plan?: string | null,
    period?: number | string | null
) => {
    if (plan === "full" || !plan) return "Полная оплата";
    const p =
        typeof period === "number"
            ? `${period} мес`
            : (period ?? "").toString().trim();
    return `Рассрочка${p ? ` ${p}` : ""}`;
};

